import styled from '@emotion/styled';
import { transparentize } from 'polished';

/**
 * Sidebar Divider
 */
export const SidebarDivider = styled.div`
    width: 100%;
    height: 1px;
    flex-shrink: 0;
    background-color: ${transparentize(0.92, '#e4e8f0')};
`;
